class TipoOperacaoAlmoxarifadoProdutoEnum {
    constructor(cod, desc) {
      this.cod = cod;
      this.desc = desc;
    }
  
    static fromcod(cod) {
      return Object.values(TipoOperacaoAlmoxarifadoProdutoEnum).find(status => status.cod === cod);
    }
  
    static fromDesc(desc) {
      return Object.values(TipoOperacaoAlmoxarifadoProdutoEnum).find(status => status.desc === desc);
    }
  }
  
  TipoOperacaoAlmoxarifadoProdutoEnum.CONSULTA = new TipoOperacaoAlmoxarifadoProdutoEnum(1, "CONSULTA");
  TipoOperacaoAlmoxarifadoProdutoEnum.PEDIDO = new TipoOperacaoAlmoxarifadoProdutoEnum(2, "PEDIDO");
  TipoOperacaoAlmoxarifadoProdutoEnum.DEVOLUCAO = new TipoOperacaoAlmoxarifadoProdutoEnum(3, "DEVOLUÇÃO");


  export default TipoOperacaoAlmoxarifadoProdutoEnum;